import {
  findApi,
  findFeed,
  hasApiIdPattern } from './aufschaltung.js'


function apiExistsInAufschaltung (context, apiNickname) {
    const aufschaltung = context.aufschaltung
    const api = findApi({aufschaltung}, {nickname: apiNickname})
    return api && api.nickname === apiNickname
  }

function feedExistsForProfileAndApi (context, api) {
  return !!findFeed({
    aufschaltung: context.aufschaltung,
    navigation: {
      profile: context.navigation.profile,
      api: api }})
}

function checkApiIdPattern(context, api_id_pattern) {
  return hasApiIdPattern({
    aufschaltung: context.aufschaltung,
    navigation: {
      profile_nickname: context.navigation.profile,
      api_id_pattern: api_id_pattern
    }
  })
}

function cardMatchesContext ({card, context}) {
  if (!card.matches) {
    return false
  }
  // card_def has 'matches()' method that decides if the card is applicable to the given context -- this might become an ES-Query at the backend
  return card.matches(context)
}

export {
  apiExistsInAufschaltung,
  checkApiIdPattern,
  feedExistsForProfileAndApi,
  cardMatchesContext }



// WEBPACK FOOTER //
// ./src/all_cards/card_helper.js